import { magicConfig, RoutablePage, SessionChange, MagicConfigMixin, ModalMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { magic } from '@gig/magic-sdk';
import { USER_SET_REQUIRES_TERMS_ACCEPTANCE, USER_JURISDICTION_QUERY } from '@gig/magic-messages';
import { CONSENTS_NAMESPACE } from '../../../store/modules/consents/consents.store.js';
import { store } from '../../../store/index.js';
import { Jurisdiction } from '@gig/magic-jurisdictions';

var consentsModule = namespace(CONSENTS_NAMESPACE);
/**
 * The Terms Updated prompter opens the terms updated prompt
 * component when required.
 */
var TermsUpdatedPrompterComponent = /** @class */ (function (_super) {
    __extends(TermsUpdatedPrompterComponent, _super);
    function TermsUpdatedPrompterComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TermsUpdatedPrompterComponent.prototype.render = function () {
        return null;
    };
    TermsUpdatedPrompterComponent.prototype.handleSessionChange = function (isLoggedIn) {
        var user = magic.session.getUser();
        if (isLoggedIn && user) {
            // Parse as UTC time
            var timeRegistered = Date.parse(user.createdDate + 'Z');
            var isNewUser = Date.now() - timeRegistered <= 60000;
            // Avoid prompting to newly registered/recently registered users if backend doesnt save consents in time.
            if (isNewUser) {
                return;
            }
            this.fetchPendingConsents(magicConfig.language);
        }
        else {
            this.clearPendingConsents();
        }
    };
    TermsUpdatedPrompterComponent.prototype.publishPendingConsents = function () {
        var hasPending = this.pendingConsents.length > 0;
        window.commandBus.publish(USER_SET_REQUIRES_TERMS_ACCEPTANCE, hasPending);
    };
    TermsUpdatedPrompterComponent.prototype.checkModalStatus = function () {
        var hasPending = this.pendingConsents.length > 0;
        if (hasPending && !this.shouldHide) {
            this.openTermsModal();
        }
        else {
            this.closeModal();
        }
        return hasPending;
    };
    TermsUpdatedPrompterComponent.prototype.openTermsModal = function () {
        var _this = this;
        if (this.hasModal()) {
            return true;
        }
        var modalElement = this.openModal(this.renderedModal, null, {
            dismissible: false,
            keepAfterClear: true,
        });
        modalElement.addEventListener('acceptedTerms', function () { return __awaiter(_this, void 0, void 0, function () {
            var preferences, isSGA;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearPendingConsents();
                        this.closeModal();
                        return [4 /*yield*/, magic.methods.users.getPreferences()];
                    case 1:
                        preferences = _a.sent();
                        return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 2:
                        isSGA = (_a.sent()) === Jurisdiction.SGA;
                        if (!preferences.limitsConfirmed && isSGA) {
                            this.routeTo({ route: RoutablePage.SET_LIMITS });
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        modalElement.consents = this.pendingConsents;
        return true;
    };
    __decorate([
        Prop({
            type: String,
            default: 'magic-terms-updated-prompt',
        }),
        __metadata("design:type", String)
    ], TermsUpdatedPrompterComponent.prototype, "renderedModal", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TermsUpdatedPrompterComponent.prototype, "shouldHide", void 0);
    __decorate([
        consentsModule.Action('fetchPendingConsents'),
        __metadata("design:type", Function)
    ], TermsUpdatedPrompterComponent.prototype, "fetchPendingConsents", void 0);
    __decorate([
        consentsModule.Action('clearPendingConsents'),
        __metadata("design:type", Function)
    ], TermsUpdatedPrompterComponent.prototype, "clearPendingConsents", void 0);
    __decorate([
        consentsModule.Getter('pendingConsents'),
        __metadata("design:type", Array)
    ], TermsUpdatedPrompterComponent.prototype, "pendingConsents", void 0);
    __decorate([
        SessionChange({ immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], TermsUpdatedPrompterComponent.prototype, "handleSessionChange", null);
    __decorate([
        Watch('pendingConsents'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TermsUpdatedPrompterComponent.prototype, "publishPendingConsents", null);
    __decorate([
        Watch('pendingConsents'),
        Watch('shouldHide'),
        Emit('hasPendingConsents'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TermsUpdatedPrompterComponent.prototype, "checkModalStatus", null);
    TermsUpdatedPrompterComponent = __decorate([
        Component({
            name: 'terms-updated-prompter',
            store: store,
        })
    ], TermsUpdatedPrompterComponent);
    return TermsUpdatedPrompterComponent;
}(Mixins(MagicConfigMixin, ModalMixin)));

export default TermsUpdatedPrompterComponent;
